import React from 'react';
import CardItem from './Items/CardItem';
import { SOURCE_URL } from '../../../config';
import { IPriceOption, PackInfo, Plan } from '../types';
import { useAppDispatch, useAppSelector } from '../../../stores/hook';
import { setPackInfo, setSubscribeModalStatus } from './GetStartedSlice';
import language from '../../../utils/LanguageSettings';
import { appendUtmParams } from '../../../utils/Url';

interface FeaturePlanProps {
    plans: Array<Plan>;
}

const FeaturePlan: React.FC<FeaturePlanProps> = ({ plans }) => {
    const isTvBoxPage = useAppSelector((state) => state.getStarted.isTvBoxPage);
    const dispatch = useAppDispatch();

    const onClickBtn = (e: React.MouseEvent<HTMLButtonElement>, packInfo: PackInfo) => {
        if (packInfo.PriceOptions?.length > 1) {
            dispatch(setSubscribeModalStatus(true));
            dispatch(setPackInfo(packInfo));
        } else if (packInfo.PriceOptions?.length === 1) {
            const campaign = packInfo.PriceOptions[0].Campaign;
            if (campaign) {
                if (isTvBoxPage) {
                    window.location.href = '/subscriber-enquiry';
                } else {
                    const paramName = packInfo.PriceOptions[0].EPC ? 'epc' : 'campaign';
                    let url = 'https://ssp.nowtv.now.com/choose-plan?' + paramName + '=' + packInfo.PriceOptions[0].Campaign + '&lang=' + language;
                    if (packInfo.Gift) {
                        url += '&isGift=Y';
                    }
                    window.location.href = appendUtmParams(url);
                }
            }
        }
    };

    const renderCardItem = (pack: Plan, isFeatured: boolean) => {
        const sourceUrl = `${SOURCE_URL}`;
        return (
            <CardItem
                key={pack.id}
                imgSrc={pack.attributes?.plan_img?.data?.attributes?.formats?.large?.url ? `${sourceUrl}${pack.attributes.plan_img.data.attributes.formats.large.url}` : ''}
                imgSrcFeat={pack.attributes?.featureImage?.data?.attributes?.url ? `${sourceUrl}${pack.attributes.featureImage.data.attributes.url }` : ''}
                title={pack.attributes.name}
                campaignParameter={pack.attributes.campaignParameter}
                featured={isFeatured}
                description={pack.attributes.description}
                includes={pack.attributes.includes}
                price={pack.attributes.price}
                stb_price={pack.attributes.stb_price}
                ott_12Mth_price={pack.attributes.ott_12Mth_price}
                stb_12Mth_price={pack.attributes.stb_12Mth_price}
                ottPriceDetail={pack.attributes.ottPriceDetail || ''}
                stbPriceDetail={pack.attributes.stbPriceDetail || ''}
                ottCampaign={pack.attributes.ott_campaign}
                stbCampaign={pack.attributes.stb_campaign}
                stb_12M_campaign={pack.attributes.stb_12M_campaign}
                PriceOptions={pack.attributes.PriceOptions}
                box_detail_id={pack.attributes.stb_detail_id}
                Tagline={isTvBoxPage ? pack.attributes.TaglineSTB : pack.attributes.TaglineOTT}
                Gift={pack.attributes.PriceOptions && pack.attributes.PriceOptions.length === 1 ? pack.attributes.PriceOptions[0].Gift : false}
                onClick={(e) => {
                    const packInfo: PackInfo = { 
                        name: pack.attributes.name, 
                        PriceOptions: pack.attributes?.PriceOptions, 
                        optionsContext: pack.attributes.optionsContext, 
                        Gift: pack.attributes.PriceOptions && pack.attributes.PriceOptions.length === 1 ? pack.attributes.PriceOptions[0].Gift : false 
                    };
                    onClickBtn(e, packInfo);
                }}
            />
        );
    };

    const planGroups = [];
    let currentRow: Plan[] = [];
    let singleItemBuffer: Plan[] = [];

    plans.forEach((pack, i) => {
        const isFeatured = isTvBoxPage ? pack.attributes.featuredSTB : pack.attributes.featured;

        if (isFeatured || currentRow.length === 2) {
            if (currentRow.length > 0) {
                planGroups.push(
                    <div key={`group-${i}`} className="row">
                        {currentRow.map((pack) => renderCardItem(pack, isFeatured))}
                    </div>
                );
            }
            currentRow = [];
        }

        currentRow.push(pack);

        if (isFeatured) {
            planGroups.push(
                <div key={`group-${i}`} className="row">
                    {currentRow.map((pack) => renderCardItem(pack, isFeatured))}
                </div>
            );
            currentRow = [];
        }

        if (currentRow.length === 1 && !isFeatured) {
            singleItemBuffer.push(currentRow[0]);
            currentRow = [];
        }

        if (singleItemBuffer.length === 2) {
            planGroups.push(
                <div key={`group-single-${i}`} className="row">
                    {singleItemBuffer.map((pack) => renderCardItem(pack, isFeatured))}
                </div>
            );
            singleItemBuffer = [];
        }
    });

    if (currentRow.length > 0) {
        planGroups.push(
            <div key={`group-last`} className="row">
                {currentRow.map((pack) => renderCardItem(pack, isTvBoxPage ? pack.attributes.featuredSTB : pack.attributes.featured))}
            </div>
        );
    }

    if (singleItemBuffer.length > 0) {
        planGroups.push(
            <div key={`group-single-last`} className="row">
                {singleItemBuffer.map((pack) => renderCardItem(pack, isTvBoxPage ? pack.attributes.featuredSTB : pack.attributes.featured))}
            </div>
        );
    }

    return (
        <>
            {plans.length > 0 ? planGroups : <p></p>}
        </>
    );
};

export default FeaturePlan;